var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isVerticalRulerDisplayed || _vm.isHorizontalRulerDisplayed)?_c('div',{staticClass:"ruler",style:({
    '--ruler1-space': _vm.lowerTicksSpace,
    '--ruler2-space': _vm.higherTicksSpace,
  })},[(_vm.isHorizontalRulerDisplayed)?_c('ul',{staticClass:"ruler-x"},[_c('li'),_vm._l((_vm.points),function(point){return _c('li',{key:point},[_vm._v(_vm._s(point))])})],2):_vm._e(),(_vm.isVerticalRulerDisplayed)?_c('ul',{staticClass:"ruler-y",style:({
    '--rulery-background': _vm.isDisabled ? 'none' : ' rgb(244, 244, 244)',
  })},[_c('li'),_vm._l((_vm.points),function(point){return _c('li',{key:point},[_vm._v(_vm._s(point))])})],2):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }